import React from 'react'
import { Grid, Icon, List, Image } from 'semantic-ui-react';
import Labels from './../../../../common/Labels'
import ImageAvater from '../../../../drive/Components/ImageAvater';

class Detail extends React.Component {

    render() {
        let practiceData = this.props.selectedDataById

        return (
            <Grid columns={4} >
                <Grid.Row>
                    <Grid.Column width={10} >
                        <Labels
                            name="Name"
                            text={practiceData && practiceData.name}
                        />
                        {this.props.playbookOwnerDetails ?
                            <Labels
                                name="Playbook Designer"
                                text={
                                    <List verticalAlign='middle'>
                                        <List.Item>
                                            <ImageAvater user={this.props.playbookOwnerDetails} />
                                            <div className="float-left f_semiBold" style={{ padding: '8px 0' }}>
                                                {this.props.playbookOwnerDetails.firstName} &nbsp;
                                                    {this.props.playbookOwnerDetails.lastName}
                                            </div>
                                        </List.Item>
                                    </List>
                                }

                            /> : null}
                        <Labels
                            name="Description"
                            text={practiceData && practiceData.description}
                            htmlView={true}
                        />
                        {/* version */}
                        <Labels
                            name="Current Version"
                            text={practiceData && practiceData.version}
                            htmlView={true}
                        />
                        <Labels
                            name="Pre-requisities"
                            text={practiceData && practiceData.prerequisite ? practiceData.prerequisite : "No Pre-requisite Added"}
                            htmlView={true}
                        />
                        <Labels
                            name="Category"
                            text={
                                <span>
                                    {practiceData.baseCategory.name}&nbsp;<Icon name="chevron right" />
                                    {practiceData.category.name}&nbsp;<Icon name="chevron right" />
                                    {practiceData.subCategory.name}
                                </span>
                            }
                        />
                    </Grid.Column>
                    <Grid.Column width={6}>
                        <Labels
                            name="Tags"
                            text={practiceData && practiceData.tags && practiceData.tags.length ?
                                practiceData.tags.map(function (tags, index) {
                                    return (
                                        <div key={index} className="PublishTags" >{tags}</div>
                                    );
                                }, this)
                                : <span>No Tags are added.</span>}
                        />
                    </Grid.Column>

                </Grid.Row>
            </Grid>
        )
    }
}

export default Detail